// extracted by mini-css-extract-plugin
export default {"text":"MobileLogoText_text__l6OnA","hidden":"MobileLogoText_hidden__GJAb4"};